<script setup>
import PropertyTag from '@/Components/PropertyTag';
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3';

defineProps({
    property: {
        id: Number,
        external_id: Number,
        languages: Object,
        amenities:Object,
        reference: String,
        hash: String,
    },
});

const openModal = (property_id) => {
    emitter.emit('propertyModal', { property_id })
}
</script>

<script>

export default {
    data(){
        return {
            title: '',
            desc: '',
            amenities: [],
            images: [],
            location: {},
            primary_image: '',
            whatsapp_url: '',
            propertyType: '',
            propertyPrice: [],
            property_location: ''
        };
    },
    mounted() {
        let languages = this.property.languages;
        this.images = (this.property.images != null) ? JSON.parse(this.property.images) : [];
        this.location = this.property.location != null ? JSON.parse(JSON.stringify(this.property.location)) : null;

        if(this.location){
            this.property_location = ((this.location.tower != null ? this.location.tower + ', ' : '') + (this.location.sub_community != null ? this.location.sub_community + ', ' : '') + (this.location.community != null ? this.location.community + ', ' : '') + (this.location.city != null ? this.location.city : '')) + '.';
        }

        if(this.images && this.images.length > 0){
            let image = JSON.parse(JSON.stringify(this.images[0]));
            if(image){
                image = JSON.parse(JSON.stringify(image));
                if(image){
                    this.primary_image = JSON.parse(JSON.stringify(image.medium))
                }
            }
        }

        if(languages){
            languages = JSON.parse(languages);
            if(languages){
                this.title = languages[0].title;
                this.desc= languages[0].description;
            }
        }

        let amenities = this.property.amenities;
        if(amenities){
            amenities = JSON.parse(amenities);
            if(amenities){
                this.amenities = amenities;
            }
        }

        if(this.property.price != null){
            let price = JSON.parse(this.property.price);
            if(price){
                this.propertyType = price.offering_type;
                if(price.prices){
                    price = JSON.parse(JSON.stringify(price.prices));
                    if(price){
                        price.forEach(element => {
                            this.propertyPrice.push(element.value + ' AED / ' + element.period)
                        });
                    }
                }
            }
        }

        this.whatsapp_url = 'https://wa.me/' + usePage().props.value.whatsapp_phone + '?text=' + encodeURIComponent(`Hi, I found a property listing "${this.property.reference}" on your website ${usePage().props.value.app_name} and would like to know more about it.`);
    },
    methods: {
        readMore(property_hash){
            Inertia.get(this.route('property.showSlug', {property: property_hash}))
        }
    }
}
</script>

<template>
    <div class="property-card mt-4 mt-lg-1 mt-xl-4">
        <div class="row m-md-0">
            <div class="col-lg-12 px-md-0" @click="readMore(property.hash)">
                <div class="property-img-wrapper">
                    <figure class="property-card-img">
                        <img :src="(primary_image != '') ? primary_image.link : asset('/images/image-not-found-property.jpg')" class="with-loading" onerror="this.src='/images/image-not-found-property.jpg'">
                    </figure>
                    <div class="image-count">
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#000" stroke-width="2" d="M1,1 L19,1 L19,19 L1,19 L1,1 Z M5,19 L5,23 L23,23 L23,5.97061363 L18.9998921,5.97061363 M6,8 C6.55228475,8 7,7.55228475 7,7 C7,6.44771525 6.55228475,6 6,6 C5.44771525,6 5,6.44771525 5,7 C5,7.55228475 5.44771525,8 6,8 Z M2,18 L7,12 L10,15 L14,10 L19,16"></path></svg>
                        <span>{{ images.length }}</span>
                    </div>
                    <div class="image-tag" v-if="propertyType">{{ propertyType }}</div>
                </div>
            </div>
            <div class="col-lg-12 px-md-0">
                <div class="property-card-descp">
                    <div class="descp-top ps-2" @click="readMore(property.hash)">
                        <p class="amount">{{ propertyPrice.length > 0 ? propertyPrice[0] : '&nbsp;' }}</p>
                        <h3 class="card-title text-truncate" v-html="(title.length > 40) ? title.substr(0, 35) + '...' : title"></h3>
                        <div class="location mt-2" v-if="location != null">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"></path><circle cx="256" cy="192" r="48" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle></svg>
                            <p class="address text-truncate">{{ (property_location.length > 40) ? property_location.substr(0, 35) + '...' : property_location }}</p>
                        </div>
                    </div>
                    <div class="descp-bottom">
                        <div class="property-feature" @click="readMore(property.hash)">
                            <p class="mb-0 text-truncate" v-if="property.type">{{ property.type.name }}</p>
                            <div class="">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M384 240H96V136a40.12 40.12 0 0140-40h240a40.12 40.12 0 0140 40v104zM48 416V304a64.19 64.19 0 0164-64h288a64.19 64.19 0 0164 64v112"></path><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M48 416v-8a24.07 24.07 0 0124-24h368a24.07 24.07 0 0124 24v8M112 240v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16m0 0v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16"></path></svg>
                                <span>{{ property.bedrooms }}</span>
                            </div>
                            <div class="">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M21 10H7V7c0-1.103.897-2 2-2s2 .897 2 2h2c0-2.206-1.794-4-4-4S5 4.794 5 7v3H3a1 1 0 0 0-1 1v2c0 2.606 1.674 4.823 4 5.65V22h2v-3h8v3h2v-3.35c2.326-.827 4-3.044 4-5.65v-2a1 1 0 0 0-1-1zm-1 3c0 2.206-1.794 4-4 4H8c-2.206 0-4-1.794-4-4v-1h16v1z"></path></svg>
                                <span>{{ property.bathrooms }}</span>
                            </div>
                            <p class="mb-0 text-truncate">
                                {{ property.size }} Sq. Feet.
                            </p>
                        </div>
                        <div class="contact-links">
                            <a :href="'tel:' + $page.props.phone" class="contact-link" v-if="$page.props.phone" data-toggle="tooltip" data-placement="bottom" title="Call" data-bs-toggle="tooltip" data-bs-placement="bottom">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-miterlimit="10" stroke-width="32" d="M451 374c-15.88-16-54.34-39.35-73-48.76-24.3-12.24-26.3-13.24-45.4.95-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39-47.34-61.62-50.53-76.48 5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160.15 160.15 0 0083 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64 54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159.09 159.09 0 0013.8-25.8C465 391.17 468 391.17 451 374z"></path></svg>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Email" data-bs-toggle="tooltip" data-bs-placement="bottom" >
                                <button type="button"  class="contact-link"  data-bs-toggle="modal" @click="openModal(property.id)" data-bs-target="#enquiryModal" :data-property-id="property.id" :data-title="title" :data-location="location" :data-image="primary_image" :data-reference="property.reference">
                                    <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                                </button>                          
                            </a>
                            <a target="_blank" :href="'https://wa.me/' + $page.props.whatsapp_phone + '?text=' + encodeURIComponent('Hi, I saw a property on your website with reference ' + property.reference + ' and I thought you could help me out.')" class="contact-link" data-toggle="tooltip" data-placement="bottom" title="Whats App" data-bs-toggle="tooltip" data-bs-placement="bottom" >
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path></svg>
                            </a>
                        </div>
                        <a href="javascript:void(0);" class="read-more" @click="readMore(property.hash)">
                            Read more
                        </a>
                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.card{
    width: 100%;
}

.card .card-content{
    min-height: 10rem;
    border: 1px solid rgba(0, 0, 0, 0.049);
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.061);
    border-radius: 1rem;
    margin: 1rem;
    padding: 1rem;
}
</style>